import React from 'react';
import EditarBalanza from '../../components/balanza/EditarBalanza';
import { PageWrapper } from '../../components/common';

const EditarBalanzaPage: React.FC = () => {
  return (
    <PageWrapper>
      <EditarBalanza />
    </PageWrapper>
  );
};

export default EditarBalanzaPage;










